import * as TYPES from '../types';

const initialState = {
    pagination: {
        totalCount: 0,
        activePage: 1,
        itemsCountPerPage: 1,
        totalItemsCount: 10,
        pageRangeDisplayed: 8,
    },
    expiries: [],
    payment_details: [],
    single_purchase_order: [],
    single_product: [],
    purchase_orders: [],
    display_tab: { purchase_orders: false, items: false },
    date_from: '',
    date_to: '',
    date_filter: false,
    loading: false,
    mini_loading: false,
    isSearchable: true,
    main_page: false,
    edit_page: false,
    delete_modal: false,
    history_page: false,
    purchase_order_page: false,
    product_page: false,
    print_modal: false,
    main_url: '/inventory/expiry',
    create_url: '/inventory/expiry/create',
    edit_url: '/inventory/expiry/edit',
    history_url: '/inventory/expiry/history',
    product_url: '/inventory/expiry/history/product',
    rows_to_delete: null,
    sort_order_name: null,
    sort_order_direction: null,
    set_row_checked: false,
    expiry_item: [],
    qty: 0,
    remarks: '',
    search: '',
    products: [],
    expiry_modal: false,
    expiry_view: 'all',
};

const ExpiryReducer = (state = initialState, action) => {
    switch (action.type) {
        case TYPES.SET_LOADING:
            return {
                ...state,
                loading: action.payload,
            };
        case TYPES.SET_MINI_LOADING:
            return {
                ...state,
                mini_loading: action.payload,
            };
        case TYPES.GET_EXPIRIES:
            return {
                ...state,
                expiries: action.payload.expiries,
                pagination: action.payload.pagination,
                set_row_checked: false,
            };
        case TYPES.SET_PAYMENT_DETAILS:
            return {
                ...state,
                payment_details: action.payload,
            };
        case TYPES.EXPIRY_INPUT_CHANGE:
            return {
                ...state,
                [action.payload.name]: action.payload.value,
            };
        case TYPES.SEARCH_INPUT:
            return {
                ...state,
                search: action.payload,
            };
        case TYPES.SET_PAGE:
            return {
                ...state,
                [action.payload.page]: action.payload.status,
            };
        case TYPES.EXPIRY_HISTORY_DATE_FILTER_INPUT:
            return {
                ...state,
                [action.payload.key]: action.payload.value,
            };
        case TYPES.EXPIRY_HISTORY_DATE_INPUT_CLEAR:
            return {
                ...state,
                date_from: '',
                date_to: '',
                date_filter: false,
            };
        case TYPES.EXPIRY_SET_DATE_FILTER:
            return {
                ...state,
                date_filter: action.payload,
            };
        case TYPES.GET_EXPIRY_HISTORY_PRODUCTS:
            return {
                ...state,
                products: action.payload.products,
                pagination: action.payload.pagination,
                display_tab: { purchase_orders: false, products: true },
            };
        case TYPES.GET_EXPIRY_HISTORY_SINGLE_PRODUCT:
            return {
                ...state,
                single_product: action.payload,
            };
        case TYPES.CLEAR_EXPIRY:
            return {
                ...state,
                payment_details: [], // clear payment details as well after clearing single supplier
                display_tab: { purchase_orders: false, products: false },
                search: '',
                loadingl: false,
                main_page: false,
                edit_page: false,
                delete_modal: false,
                history_page: false,
                purchase_order_page: false,
                product_page: false,
                print_modal: false,
                main_url: '/inventory/expiry',
                create_url: '/inventory/expiry/create',
                edit_url: '/inventory/expiry/edit',
                history_url: '/inventory/expiry/history',
                product_url: '/inventory/expiry/history/product',
                rows_to_delete: null,
            };
        case TYPES.SORT_BY_COLUMN:
            return {
                ...state,
                sort_order_name: action.payload.sort_order_name,
                sort_order_direction: action.payload.sort_order_direction,
            };
        case TYPES.GET_ROWS_TO_DELETE:
            return {
                ...state,
                rows_to_delete: action.payload,
            };
        case TYPES.SET_ROW_CHECKED:
            return {
                ...state,
                set_row_checked: true,
            };
        case TYPES.SET_MODAL:
            return {
                ...state,
                [action.payload.modal]: action.payload.status,
            };
        case TYPES.RETURN_CLEAR:
            return {
                ...state,
                qty: action.payload.qty,
                remarks: action.payload.remarks,
                supplier: action.payload.supplier,
                expiry_item: action.payload.expiry_item,
            };
        case TYPES.EXPIRY_UPDATE_QTY: {
            const newQty = action.payload;
            const updatedExpiryItems = state.expiry_item.map((item, index) => {
                if (index === 0) {
                    return { ...item, qty: newQty };
                }
                return item;
            });
            return {
                ...state,
                qty: newQty, // if you need to keep this separate
                expiry_item: updatedExpiryItems,
            };
        }
        case TYPES.EXPIRY_GET_PRODUCTS:
            return {
                ...state,
                products: action.payload.products,
            };
        case TYPES.STOCK_REMOVE_SCAN:
            return {
                ...state,
                pos_item: action.payload,
                search: '',
                qty: 1,
                remarks: '',
            };
        case TYPES.SET_EXPIRY:
            return {
                ...state,
                expiry_modal: action.payload,
            };
        case TYPES.EXPIRY_CHANGE_VIEW:
            return {
                ...state,
                expiry_view: action.payload,
            };
        default:
            return state;
            break;
    }
};

export default ExpiryReducer;
